module.exports = __webpack_public_path__ + "img/bg_device_mobile_big.1fab3d6c.svg";